var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyLinkDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.958 47.427H8.469C3.792 47.427 0 43.635 0 38.958V8.46899C0 3.79199 3.792 0 8.469 0H38.958C43.635 0 47.427 3.79199 47.427 8.46899V38.958C47.427 43.636 43.636 47.427 38.958 47.427Z",
    fill: "#0A0A0A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6488 18.5725L26.1665 16.0559C26.9326 15.2898 27.9717 14.8594 29.0552 14.8594C29.5917 14.8594 30.1229 14.965 30.6186 15.1703C31.1142 15.3756 31.5646 15.6766 31.9439 16.0559C32.3233 16.4353 32.6242 16.8856 32.8295 17.3813C33.0348 17.8769 33.1405 18.4081 33.1405 18.9446C33.1405 19.4811 33.0348 20.0123 32.8295 20.508C32.6242 21.0036 32.3233 21.454 31.9439 21.8333L29.4273 24.351M18.5723 23.6501L16.0547 26.1667C15.2884 26.9329 14.8579 27.9722 14.8579 29.0559C14.8579 30.1396 15.2884 31.1789 16.0547 31.9452C16.821 32.7114 17.8602 33.1419 18.9439 33.1419C20.0276 33.1419 21.0669 32.7114 21.8332 31.9452L24.3498 29.4275M26.1643 21.8333L21.831 26.1667",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyLinkDark);
export default __webpack_public_path__ + "static/media/copy-link-dark.5e4762261b620baae6e285045c8ac01e.svg";
export { ForwardRef as ReactComponent };